import * as Types from '../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetDriverLocationsQueryVariables = Types.Exact<{
  moveId: Types.Scalars['bigint']['input'];
}>;


export type GetDriverLocationsQuery = { __typename?: 'query_root', driverlocations: Array<{ __typename?: 'driverlocations', id: string, location: object, time: string }> };


export const GetDriverLocationsDocument = gql`
    query getDriverLocations($moveId: bigint!) {
  driverlocations(
    where: {move_id: {_eq: $moveId}}
    order_by: {time: asc}
    limit: 5000
  ) {
    id
    location
    time
  }
}
    `;

/**
 * __useGetDriverLocationsQuery__
 *
 * To run a query within a React component, call `useGetDriverLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverLocationsQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useGetDriverLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetDriverLocationsQuery, GetDriverLocationsQueryVariables> & ({ variables: GetDriverLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverLocationsQuery, GetDriverLocationsQueryVariables>(GetDriverLocationsDocument, options);
      }
export function useGetDriverLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverLocationsQuery, GetDriverLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverLocationsQuery, GetDriverLocationsQueryVariables>(GetDriverLocationsDocument, options);
        }
// @ts-ignore
export function useGetDriverLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverLocationsQuery, GetDriverLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriverLocationsQuery, GetDriverLocationsQueryVariables>;
export function useGetDriverLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverLocationsQuery, GetDriverLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriverLocationsQuery | undefined, GetDriverLocationsQueryVariables>;
export function useGetDriverLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverLocationsQuery, GetDriverLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverLocationsQuery, GetDriverLocationsQueryVariables>(GetDriverLocationsDocument, options);
        }
export type GetDriverLocationsQueryHookResult = ReturnType<typeof useGetDriverLocationsQuery>;
export type GetDriverLocationsLazyQueryHookResult = ReturnType<typeof useGetDriverLocationsLazyQuery>;
export type GetDriverLocationsSuspenseQueryHookResult = ReturnType<typeof useGetDriverLocationsSuspenseQuery>;
export type GetDriverLocationsQueryResult = Apollo.QueryResult<GetDriverLocationsQuery, GetDriverLocationsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/components/DriverTracker/getDriverLocations.query.gql}
 */
export async function getDriverLocations(
  variables: GetDriverLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriverLocationsQuery['driverlocations']>
export async function getDriverLocations(
  variables: GetDriverLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriverLocationsQuery>
export async function getDriverLocations(
  variables: GetDriverLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriverLocationsQuery['driverlocations'] | GetDriverLocationsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriverLocationsQuery>(
    GetDriverLocationsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.driverlocations
}